import { CARD_TYPE_MAP } from '../cardTypes';

// Doesn't require partner details or wedding date during signup
const CARD_TYPES_WITH_SIMPLE_SIGNUP = [CARD_TYPE_MAP.holiday, CARD_TYPE_MAP.weddingShower] as const;

export type CardWithSimpleSignup = (typeof CARD_TYPES_WITH_SIMPLE_SIGNUP)[number];

export const isCardWithSimpleSignup = (type?: string): type is CardWithSimpleSignup => {
  if (!type) return false;
  return (CARD_TYPES_WITH_SIMPLE_SIGNUP as Readonly<string[]>).includes(type);
};
